import React, { Component } from "react";
import { Search } from "../../Shared";
import Utils from "../../../lib/utils";
import ApplicantDashboard from "../../Applicants/Dashboard";
import EmployerDashboard from "../../Employers/Dashboard";
import { Container, InnerContainer } from "./style.ts";

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keywords: "",
      location: "",
    };
  }

  handleSubmit = (keywords, location) => {
    const { history } = this.props;
    const url = Utils.getSearchUrl(keywords, location);
    Utils.resetJobsFilter();
    history.push(url);
    localStorage.setItem("flag", true);
  };

  render() {
    const { user, location } = this.props;
    const { keywords, location: stateLocation } = this.state;
    return (
      <Container>
        {location.pathname.indexOf("edit") <= -1 && ( // Hides search on edit pages
          <Search
            search={this.handleSubmit}
            keywords={keywords}
            location={stateLocation}
          />
        )}
        <InnerContainer>
          <div className="container">
            {user && Utils.isApplicant(user) ? (
              <ApplicantDashboard {...this.props} />
            ) : (
              <EmployerDashboard {...this.props} />
            )}
          </div>
        </InnerContainer>
      </Container>
    );
  }
}


